import React, { useState, useEffect, useRef, Suspense } from "react";

import Header from "./header4";
import Footer from "./footer";
import Glossar from "./glossarblogs";

// Memoize the components
const MemoizedHeader = React.memo(Header);


const divsToUpdate = document.querySelectorAll(".boilerplate-update-me-glossar");

divsToUpdate.forEach((div) => {
  const data = JSON.parse(div.querySelector("pre").innerText);
  ReactDOM.render(<GlossarPage {...data} />, div);
  div.classList.remove("boilerplate-update-me-glossar");
});



function GlossarPage() {
  return (
    <div>
      <div>
        <MemoizedHeader title ="Glossar" />
      </div>

<Glossar />

  

        <Footer />


    </div>
  );
}
